<template>
<div>

    <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>
            <nav class="admin breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li><router-link tag="a" :to="{name: 'admin'}">Admin</router-link></li>
                <li class="is-active"><a href="#">Plays</a></li>
              </ul>
            </nav>
                Edit plays
            </h1>
        </div>
      </section>
    </div>


    <div class="section">

        <div class="container">
            <h2 class="title">Plays</h2>

            <table class="table is-hoverable">
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th width="100" title="Main play displayed at top of homepage">Main play featured on Home</th>
                        <th width="100" title="Current production">Current production</th>
                        <th width="100" title="Future production">Future production</th>
                        <th width="100" title="Show future production at bottom of homepage">Future production on Home</th>
                        <th width="100" title="Open to auditions">Open to Auditions</th>
                        <th width="100" title="Previous production">Previous production</th>
                        <th width="100" title="Not displayed, but affects order">Date (affects order)</th>
                        <!-- <th width="100" title="Archive">Archive</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in plays" :key="item._id">
                        <td>
                            <router-link tag="a" :to="{name: 'admin-play', params: {slug: item.slug}}" class="nav-link">Edit</router-link>
                        </td>
                        <td>
                            <router-link tag="a" :to="{name: 'play', params: {slug: item.slug}}" class="nav-link" target="_blank" :class="{disabled: !item.slug}">View</router-link>
                        </td>
                        <td>
                            {{ item.title || '...' }} &nbsp; &nbsp; &nbsp; 
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('featured')" v-if="item.status" onclick="return false;" />
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('current')" v-if="item.status" onclick="return false;" />
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('upcoming')" v-if="item.status" onclick="return false;" />
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('homepage')" v-if="item.status" onclick="return false;" />
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('audition')" v-if="item.status" onclick="return false;" />
                        </td>
                        <td>
                            <input type="checkbox" :checked="item.status.includes('previousproduction')" v-if="item.status" onclick="return false;" />
                        </td>
                        <!-- <td>
                            <input type="checkbox" :checked="item.status.includes('archive')" v-if="item.status" onclick="return false;" />
                        </td> -->
                        <td>
                            {{ prettifydate(item.dates.startdate) }}
                        </td>
                        <td>
                            <button class="button is-small" @click="deletePlay(item._id)" v-if="item._id">Delete</button>
                        </td>
                        
                    </tr>
                </tbody>
            </table>

            <div class="field">
              <div class="control">
                <button class="button is-text" @click="createPlay">+ Add Play</button>
              </div>
            </div>

        </div>

    </div>

</div>
</template>

<script>
import Api from '@/config/Api'
import { mapState } from 'vuex'
var moment = require('moment');

//import ProductGroupCards from '../cards/ProductGroupCards';
//import ProductCards from '../cards/ProductCards';

export default {
    name: 'adminPlays',
    data() {
        return {
            plays: [{
                slug: "/",
                status: [''],
                dates: { startdate: '' }
            }],
        }
    },
    components: {
        //ProductGroupCards,
        //ProductCards
    },
    computed: {
        ...mapState({profile: state => state.user.profile}),
        country() {
            return this.$store.getters.getCountry
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            Api().get('/api/plays')
            .then(response => {
                this.plays = response.data;
            });
        },
        async createPlay() {            
            var play = {}
            Api().post(`/api/plays/`, play)
            .then(response => {
              this.$swal('Created new play!', '', 'success');
              this.fetch(); //this.plays.push(play);
            })
            .catch((error) => {
              console.log("errorrrr:",error.response.data);
              const message = error.response.data.message || error.response.data;
              this.$swal('Oh oo!', `${message}`, 'error');
            });
        },
        async deletePlay(playId) {            
            Api().delete(`/api/plays/${playId}`)
            .then(response => {
              this.$swal('Deleted play', '', 'success');
              this.plays = this.plays.filter(x => x._id != playId);

            })
            .catch((error) => {
              var message;
              if (error.response) message = error.response;
              if (error.response.data) message = error.response.data;
              if (error.response.data.message) message = error.response.data.message;
              console.log("errorrrr:",message);
              this.$swal('Oh oo!', `${message}`, 'error');
            });
        },
        prettifydate(date) {
            if (!date) return "-";
            return moment(date).format("DD-MM-YY");
        }
    }
  }
</script>

<style scoped>
table {
    table-layout: fixed;
}
table th, table td {
    word-wrap: break-word
}
table th {
    font-size: 90%;
}
a.disabled {
    pointer-events: none;
    color: lightgrey;
}

</style>


// WEBPACK FOOTER //
// src/components/accounts/AdminPlays.vue